import { useState, useEffect } from "react";
import { Space, Card, Switch, Typography, message, Spin } from "antd";
import { DeviceData, LastMessage, SwitchOnOff } from "../../model/model";
import SessionStore from "../../model/SessionStore";

const { Text } = Typography;

interface IProps {
  deviceData: DeviceData;
}

function DeviceSwitches(props: IProps) {
  const [lastMessage, setLastMessage] = useState<LastMessage | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  const { deviceData } = props;

  useEffect(() => {
    const bearer = SessionStore.getBearer();
    SessionStore.getClient().getDeviceLastMetric(deviceData.id, bearer)
      .then((resp) => {
        setLastMessage(resp.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [deviceData.id]);

  const handleSwitch = (coilIndex: number, checked: boolean) => {
    const cmd: SwitchOnOff = {
      coil: coilIndex,
      on: checked,
      devId: deviceData.id,
    };
    SessionStore.getClient().switchOnOff(cmd, SessionStore.getBearer()).then(() => {
      messageApi.success(`Switch ${coilIndex + 1} turned ${checked ? "ON" : "OFF"}`);
      // Update local state
      setLastMessage((prev) => {
        if (!prev) return prev;
        const newCoils = [...(prev.coils || [])];
        newCoils[coilIndex] = checked;
        return { ...prev, coils: newCoils };
      });
    }).catch((err) => {
      messageApi.error(`Failed to switch: ${err.message}`);
    });
  };

  if (loading) {
    return <Spin />;
  }

  const coilsCount = deviceData.coils ? deviceData.coils.length : 0;

  if (coilsCount === 0) {
    return <Text type="secondary">Device has no switches (coils).</Text>;
  }

  const coilStatuses: boolean[] = lastMessage?.coils || [];

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      {contextHolder}
      <Space wrap>
        {Array.from({ length: coilsCount }, (_, i) => (
          <Card key={i} size="small" style={{ minWidth: 120 }}>
            <Space direction="vertical" align="center">
              <Text>{deviceData.coils?.[i] || `Switch ${i + 1}`}</Text>
              <Switch
                checked={!!coilStatuses[i]}
                onChange={(checked) => handleSwitch(i, checked)}
                checkedChildren="ON"
                unCheckedChildren="OFF"
              />
            </Space>
          </Card>
        ))}
      </Space>
    </Space>
  );
}

export default DeviceSwitches;
